import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
} from '@mui/material';
import {
  People,
  Settings,
  Security,
  Notifications,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import UserManagement from './UserManagement';
import SystemSettings from './SystemSettings';
import AlertasConfig from './AlertasConfig';

const TabPanel = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && (
      <Box sx={{ py: 3 }}>
        {children}
      </Box>
    )}
  </div>
);

const AdminPanel = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
          Panel de Administración
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Gestiona usuarios, roles, permisos y configuración del sistema
        </Typography>
      </Box>

      <Paper sx={{ borderRadius: '20px', overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'rgba(59, 130, 246, 0.03)' }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            sx={{
              '& .MuiTab-root': {
                minHeight: 72,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600,
              },
            }}
          >
            <Tab
              icon={<People />}
              iconPosition="start"
              label="Gestión de Usuarios"
            />
            <Tab
              icon={<Settings />}
              iconPosition="start"
              label="Configuración del Sistema"
            />
            <Tab
              icon={<Notifications />}
              iconPosition="start"
              label="Alertas por Email"
            />
            <Tab
              icon={<Security />}
              iconPosition="start"
              label="Roles y Permisos"
            />
          </Tabs>
        </Box>

        <Box sx={{ p: 3 }}>
          <TabPanel value={currentTab} index={0}>
            <UserManagement />
          </TabPanel>

          <TabPanel value={currentTab} index={1}>
            <SystemSettings />
          </TabPanel>

          <TabPanel value={currentTab} index={2}>
            <AlertasConfig />
          </TabPanel>

          <TabPanel value={currentTab} index={3}>
            <Box sx={{ textAlign: 'center', py: 8 }}>
              <Security sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                Gestión de Roles y Permisos
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Los roles disponibles son: admin, user, guest
                <br />
                Los permisos incluyen: read, write, delete, admin
              </Typography>
            </Box>
          </TabPanel>
        </Box>
      </Paper>
    </motion.div>
  );
};

export default AdminPanel;
